import { render, staticRenderFns } from "./KnowledgeBase.vue?vue&type=template&id=2dc22248&scoped=true"
import script from "./KnowledgeBase.vue?vue&type=script&lang=ts"
export * from "./KnowledgeBase.vue?vue&type=script&lang=ts"
import style0 from "./KnowledgeBase.vue?vue&type=style&index=0&id=2dc22248&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dc22248",
  null
  
)

export default component.exports